// importing images
import seraph from "../../assets/images/portfolio/image-seraph.jpg";
import seraphTab from "../../assets/images/portfolio/image-seraph-tab.jpg";
import seraphMob from "../../assets/images/portfolio/image-seraph-mob.jpg";

import eebox from "../../assets/images/portfolio/image-eebox.jpg";
import eeboxTab from "../../assets/images/portfolio/image-eebox-tab.jpg";
import eeboxMob from "../../assets/images/portfolio/image-eebox-mob.jpg";

import federal from "../../assets/images/portfolio/image-federal.jpg";
import federalTab from "../../assets/images/portfolio/image-federal-tab.jpg";
import federalMob from "../../assets/images/portfolio/image-federal-mob.jpg";

import delSol from "../../assets/images/portfolio/image-del-sol.jpg";
import delSolTab from "../../assets/images/portfolio/image-del-sol-tab.jpg";
import delSolMob from "../../assets/images/portfolio/image-del-sol-mob.jpg";

import leProto from "../../assets/images/portfolio/image-prototype.jpg";
import leProtoTab from "../../assets/images/portfolio/image-prototype-tab.jpg";
import leProtoMob from "../../assets/images/portfolio/image-prototype-mob.jpg";

import bTower from "../../assets/images/portfolio/image-228b.jpg";
import bTowerTab from "../../assets/images/portfolio/image-228b-tab.jpg";
import bTowerMob from "../../assets/images/portfolio/image-228b-mob.jpg";

import edelweiss from "../../assets/images/portfolio/image-edelweiss.jpg";
import edelweissTab from "../../assets/images/portfolio/image-edelweiss-tab.jpg";
import edelweissMob from "../../assets/images/portfolio/image-edelweiss-mob.jpg";

import netcry from "../../assets/images/portfolio/image-netcry.jpg";
import netcryTab from "../../assets/images/portfolio/image-netcry-tab.jpg";
import netcryMob from "../../assets/images/portfolio/image-netcry-mob.jpg";

import hypers from "../../assets/images/portfolio/image-hypers.jpg";
import hypersTab from "../../assets/images/portfolio/image-hypers-tab.jpg";
import hypersMob from "../../assets/images/portfolio/image-hypers-mob.jpg";

import sxiv from "../../assets/images/portfolio/image-sxiv.jpg";
import sxivTab from "../../assets/images/portfolio/image-sxiv-tab.jpg";
import sxivMob from "../../assets/images/portfolio/image-sxiv-mob.jpg";

import trinity from "../../assets/images/portfolio/image-trinity.jpg";
import trinityTab from "../../assets/images/portfolio/image-trinity-tab.jpg";
import trinityMob from "../../assets/images/portfolio/image-trinity-mob.jpg";

import paramour from "../../assets/images/portfolio/image-paramour.jpg";
import paramourTab from "../../assets/images/portfolio/image-paramour-tab.jpg";
import paramourMob from "../../assets/images/portfolio/image-paramour-mob.jpg";

const projectsData = [
	{
		id: 1,
		title: "Seraph Station",
		image: {
			mobile: seraphMob,
			tablet: seraphTab,
			desktop: seraph,
		},
		date: "September 2019",
	},
	{
		id: 2,
		title: "Eebox Building",
		image: {
			mobile: eeboxMob,
			tablet: eeboxTab,
			desktop: eebox,
		},
		date: "August 2017",
	},
	{
		id: 3,
		title: "Federal II Tower",
		image: {
			mobile: federalMob,
			tablet: federalTab,
			desktop: federal,
		},
		date: "March 2017",
	},
	{
		id: 4,
		title: "Project Del Sol",
		image: {
			mobile: delSolMob,
			tablet: delSolTab,
			desktop: delSol,
		},
		date: "January 2016",
	},
	{
		id: 5,
		title: "Le Prototype",
		image: {
			mobile: leProtoMob,
			tablet: leProtoTab,
			desktop: leProto,
		},
		date: "October 2015",
	},
	{
		id: 6,
		title: "228B Tower",
		image: {
			mobile: bTowerMob,
			tablet: bTowerTab,
			desktop: bTower,
		},
		date: "April 2015",
	},
	{
		id: 7,
		title: "Grand Edelweiss Hotel",
		image: {
			mobile: edelweissMob,
			tablet: edelweissTab,
			desktop: edelweiss,
		},
		date: "December 2013",
	},
	{
		id: 8,
		title: "Netcry Tower",
		image: {
			mobile: netcryMob,
			tablet: netcryTab,
			desktop: netcry,
		},
		date: "August 2012",
	},
	{
		id: 9,
		title: "Hypers",
		image: {
			mobile: hypersMob,
			tablet: hypersTab,
			desktop: hypers,
		},
		date: "January 2012",
	},
	{
		id: 10,
		title: "SXIV Tower",
		image: {
			mobile: sxivMob,
			tablet: sxivTab,
			desktop: sxiv,
		},
		date: "March 2011",
	},
	{
		id: 12,
		title: "Project Paramour",
		image: {
			mobile: trinityMob,
			tablet: trinityTab,
			desktop: trinity,
		},
		date: "February 2008",
	},
	{
		id: 13,
		title: "Trinity Bank Tower",
		image: {
			mobile: paramourMob,
			tablet: paramourTab,
			desktop: paramour,
		},
		date: "September 2010",
	},
];

export default projectsData;
